import { api } from './api'

export interface Lead {
  id: string
  chatbot_id: string
  conversation_id?: string
  session_id?: string
  name?: string
  email?: string
  phone?: string
  notes?: string
  source?: string
  created_at?: string
}

export interface LeadsResponse {
  leads: Lead[]
  total: number
  limit: number
  offset: number
}

export const leadsService = {
  async list(chatbotId: string, limit = 100, offset = 0): Promise<LeadsResponse> {
    const response = await api.get(`/chatbots/${chatbotId}/leads`, {
      params: { limit, offset },
    })
    return response.data
  },

  async exportCsv(chatbotId: string): Promise<Blob> {
    const response = await api.get(`/chatbots/${chatbotId}/leads`, {
      params: { format: 'csv' },
      responseType: 'blob',
    })
    return response.data
  },

  async deleteLead(leadId: string): Promise<void> {
    await api.delete(`/leads/${leadId}`)
  },

  async bulkDelete(chatbotId: string): Promise<{ deleted: number }> {
    const response = await api.delete(`/chatbots/${chatbotId}/leads`)
    return response.data
  },
}
